import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_291: DocMigration = {
  maxSchemaVersion: "0.0.291",
  description: "Delete straight skeleton roof systems, delete type from other roof systems",
  apply(json: any): any {
    for (const id in json.roofSystems) {
      const roofSystem = json.roofSystems[id];

      if (roofSystem.type !== "MULTI_GABLE") {
        delete json.roofSystems[id];
      } else {
        delete json.roofSystems[id].type;
      }
    }

    for (const id in json.roofs) {
      delete json.roofs[id].type;
    }

    return json;
  },
};

export default migration_0_0_291;
